import '../../../gui/gh_radio_button.js'
import '../../../gui/gh_switch/gh_switch.js'
import './groupsTable.scss';
import '../groupUsers.directive.js';
import '../members_table/membersTable.directive.js'
import '../apps_table/appsTable.directive.js'
require('../../../core/localizationService/localizationService.js');
angular.module('groupsTableModule', ['localizationModule'])

  .directive('groupsTable', ['GhDialog', function (GhDialog) {
    return {
      restrict: 'E',
      scope: {
        groups: '='
      },

      controller: ['$scope', 'localizationService', function ($scope, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        const translate = $scope.translate;

        $scope.options = [{
          name: translate('Blocked'),
          value: 0,
          color: '#000000'
        }, {
          name: translate('Member'),
          value: 1,
          color: '#00FF00'
        }, {
          name: translate('Admin'),
          value: 2,
          color: '#FF0000'
        },{
          name: translate('Owner'),
          value: 3,
          color: '#0FB5FF'
        }]

        $scope.showDeleteGroupPopup = function (group, onDeleted) {
          GhDialog.show({
            position: 'center',
            toolbar: false,
            template: {
              toolbar: '',
              resizable: false,
              content: `
              <div class="delete_group-popup">
                <div class="dialog-share-group">
                  <span gh-icon="rubbish FF0D0D 65px"></span>
                  <p class="dialog-share-group__title">{{translate('Deleting Group!')}}</p>
                </div>
                <div class="dialog-share-group__content">
                  <p class="info">{{translate('Do you really want to delete group? You will not be able to restore it.')}}</p>
                  <div class="dialog-share-group__content__buttons">
                    <button class="dialog-share-group__content__buttons__add btn btn-blue-reverse" ng-click="deleteGroup()">{{translate('Delete')}}</button>
                    <button class="dialog-share-group__content__buttons__cancel btn btn-blue" ng-click="cancel()">{{translate('Cancel')}}</button>
                  </div>
                </div>
              </div>`,
            },
            locals: {
              group,
              groups: $scope.groups
            },
              controller: ['$scope', 'groups', 'localizationService', function ($scope, groups, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                $scope.deleteGroup = function() {
                  try {
                    gudhub.groupSharing.deleteGroup(group.group_id);
                    groups.splice(groups.indexOf(group), 1)
                    if (onDeleted) onDeleted();
                    $scope.cancel();
                  } catch(error) {
                    console.log(error);
                  }
                }
              }]

          })
        }

        $scope.unsubscribeFromGroup = function (group) {
          GhDialog.show({
            position: 'center',
            toolbar: false,
            template: {
              toolbar: '',
              resizable: false,
              content: `
              <div class="delete_group-popup">
                <div class="dialog-share-group">
                  <span gh-icon="rubbish FF0D0D 65px"></span>
                  <p class="dialog-share-group__title">{{translate('Unsubscribing!')}}</p>
                </div>
                <div class="dialog-share-group__content">
                  <p class="info">{{translate('Do you really want to unsubscribe from')}} "{{group.group_name}}"?</p>
                  <div class="dialog-share-group__content__buttons">
                    <button class="dialog-share-group__content__buttons__add btn btn-blue-reverse" ng-click="unsubscribe()">{{translate('Unsubscribe')}}</button>
                    <button class="dialog-share-group__content__buttons__cancel btn btn-blue" ng-click="cancel()">{{translate('Cancel')}}</button>
                  </div>
                </div>
              </div>`,
            },
            locals: {
              group,
              groups: $scope.groups
            },
              controller: ['$scope', 'group', 'groups', 'localizationService', function ($scope, group, groups, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);
                $scope.group = group;

                $scope.unsubscribe = async function() {
                  try {
                    const userId = gudhub.storage.getUser().user_id;
                    await gudhub.groupSharing.deleteUserFromGroup(userId, group.group_id);
                    groups.splice(groups.indexOf(group), 1);
                    $scope.$applyAsync();
                    $scope.cancel();
                  } catch(error) {
                    console.log(error);
                  }
                }
              }]

          })
        }

        $scope.onDeleteIconClick = function (group) {
          if (group.group_permission === 2) {
            $scope.showDeleteGroupPopup(group);
          } else if (group.group_permission === 1) {
            $scope.unsubscribeFromGroup(group);
          }
        }

        $scope.openGroup = function (e, group, index) {
          $scope.groupName = group.group_name;

          const deleteIcon = document.querySelectorAll('.delete_icon')[index];
          const deleteIconSvg = document.querySelectorAll('.delete_icon svg')[index];
          const deleteIconPath = document.querySelectorAll('.delete_icon svg path')[index];
          if(e.target == deleteIcon || e.target == deleteIconPath || e.target == deleteIconSvg) return;

          const options = {
              position: 'full',
              toolbar: false,
              template: {
              toolbar: '',
                content: /*html*/
                `
                <div class="group-popup">
                  <div class="group-popup__header">
                    <div class="group_name-wrapper">
                      <input type="text" ng-model="group.group_name" ng-style="{width: this.group.group_name.length + 'ch'}" ng-change="changeValue()" class="group_name_input" readonly>
                      <span class="edit_icon" ng-show="!showChangeName && group.group_permission == 3 || group.group_permission == 2" gh-icon="pencil 0D99FF 25px normal" ng-click="editGroupName(group)"></span>
                      <div class="group_name_controls" ng-show="showChangeName">
                        <span class="save_icon" gh-icon="checked 05B52C 25px normal" ng-click="updateGroupName(group)"></span>
                        <span class="cancel_icon" gh-icon="cross FF0000 25px normal" ng-click="cancelEdit()"></span>
                      </div>
                    </div>
                    <div class="group_admins">
                      <p class="group_admins__title">{{translate('Administrators:')}}</p>
                      <group-users group="group" mode="admins"></group-users>
                    </div>
                  </div>
                  <span class="close_dialog" ng-click="cancel()" gh-icon="cross #0D99FF 30px"></span>
                  <div class="group-popup__nav-panes">
                  <div class="group-popup__nav-track" ng-class="{'--detail_open': tabDetailOpen}">
                  <div class="group-popup__tabs">
                    <div class="group-popup__tab"
                         ng-class="{'group-popup__tab--active': activeTab === 'members'}"
                         ng-click="activeTab = 'members'; tabDetailOpen = true;">
                      {{translate('Members')}}
                      <span class="group-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                    </div>
                    <div class="group-popup__tab"
                         ng-class="{'group-popup__tab--active': activeTab === 'apps'}"
                         ng-click="activeTab = 'apps'; tabDetailOpen = true;">
                      {{translate('Applications')}}
                      <span class="group-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                    </div>
                    <div class="group-popup__tab"
                         ng-show="group.group_permission == 2 || group.group_permission == 3"
                         ng-class="{'group-popup__tab--active': activeTab === 'settings'}"
                         ng-click="activeTab = 'settings'; tabDetailOpen = true;">
                      {{translate('Settings')}}
                      <span class="group-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                    </div>
                  </div>
                  <div class="group-popup__content-pane">
                    <div class="group-popup__mobile-header">
                      <span class="group-popup__mobile-back" ng-click="tabDetailOpen = false">
                        <span gh-icon="arrow_left 0893d2 24px normal"></span>
                      </span>
                      <span ng-if="activeTab === 'members'">{{translate('Members')}}</span>
                      <span ng-if="activeTab === 'apps'">{{translate('Applications')}}</span>
                      <span ng-if="activeTab === 'settings'">{{translate('Settings')}}</span>
                    </div>
                    <div class="group-popup__content">
                      <div class="group_members" ng-show="activeTab === 'members'">
                        <members-table group="group"></members-table>
                      </div>
                      <div class="apps" ng-show="activeTab === 'apps'">
                        <apps-table group="group"></apps-table>
                      </div>
                      <div class="group_settings" ng-show="(group.group_permission == 2 || group.group_permission == 3) && activeTab === 'settings'">
                        <div class="group_settings__row">
                          <span class="group_settings__label">{{translate('Group name')}}</span>
                          <div class="group_settings__name-view" ng-show="!editingName">
                            <span class="group_settings__name-value">{{group.group_name}}</span>
                            <span class="edit_icon" gh-icon="pencil 0D99FF 20px normal" ng-click="enableEditName()"></span>
                          </div>
                          <div class="group_settings__name-edit" ng-show="editingName">
                            <input type="text" ng-model="nameDraft" class="group_settings__name-input">
                            <span class="save_icon" gh-icon="checked 05B52C 22px normal" ng-click="saveName()"></span>
                            <span class="cancel_icon" gh-icon="cross FF0000 22px normal" ng-click="cancelEditName()"></span>
                          </div>
                        </div>
                        <div class="group_settings__row">
                          <span class="group_settings__label">{{translate('Private group')}}</span>
                          <gh-switch ng-model="group.private" ng-change="togglePrivate()" class="green"></gh-switch>
                        </div>
                        <div class="group_settings__row group_settings__row--delete">
                          <span class="group_settings__label">{{translate('Delete group')}}</span>
                          <button class="btn btn-red" ng-click="deleteGroup()">{{translate('Delete')}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
                </div>
                `
              },
              locals: {
                group,
                groupName: $scope.groupName,
                showDeleteGroupPopup: $scope.showDeleteGroupPopup
              },

              controller: ['$scope', 'group', 'groupName', 'showDeleteGroupPopup', 'localizationService', async function($scope, group, groupName, showDeleteGroupPopup, localizationService) {
                  const dictionary = localizationService.getDictionary('account_settings');
                  $scope.translate = (word) => localizationService.translate(word, dictionary);

                  $scope.group = group;
                  $scope.activeTab = 'members';
                  $scope.tabDetailOpen = false;

                  $scope.editGroupName = () => {
                    const input = document.querySelector('.group_name_input');
                    input.removeAttribute('readonly');
                    $scope.showChangeName = true;
                    input.focus();
                  }

                  $scope.changeValue = () => {
                    const input = document.querySelector('.group_name_input');
                    input.style.width = input.value.length + 1 + "ch";
                  }

                  $scope.cancelEdit = () => {
                    $scope.showChangeName = false;
                    $scope.group.group_name = groupName;
                    const input = document.querySelector('.group_name_input');
                    input.setAttribute('readonly', true);
                  }

                  $scope.updateGroupName = async (group) => {
                    if (group.group_name.length > 0) {
                      try {
                        const input = document.querySelector('.group_name_input');
                        input.setAttribute('readonly', true);
                        await gudhub.groupSharing.updateGroup(group.group_id, group.group_name);
                        groupName = group.group_name;
                        $scope.showChangeName = false;
                        $scope.$apply();
                      } catch(error) {
                        console.log(error);
                      }
                    } else {
                      return false;
                    }
                  }

                  $scope.editingName = false;
                  $scope.nameDraft = group.group_name;

                  $scope.enableEditName = () => {
                    $scope.nameDraft = group.group_name;
                    $scope.editingName = true;
                  }

                  $scope.cancelEditName = () => {
                    $scope.editingName = false;
                  }

                  $scope.saveName = async () => {
                    const name = ($scope.nameDraft || '').trim();
                    if (!name) return;
                    try {
                      await gudhub.groupSharing.updateGroup(group.group_id, name);
                      group.group_name = name;
                      groupName = name;
                      $scope.editingName = false;
                      $scope.$apply();
                    } catch(error) {
                      console.log(error);
                    }
                  }

                  $scope.deleteGroup = function() {
                    showDeleteGroupPopup(group, () => $scope.cancel());
                  }

                  $scope.togglePrivate = async () => {
                    const newValue = group.private;
                    try {
                      await gudhub.req.post({
                        url: '/api/sharing-group/update-group',
                        form: {
                          group_id: group.group_id,
                          group_name: group.group_name,
                          private: newValue
                        }
                      });
                    } catch(error) {
                      console.log(error);
                      group.private = !newValue;
                      $scope.$apply();
                    }
                  }

              }]
          }
            GhDialog.show(options);
        }
      }],

      template: /*html*/
      `<div class="listing_table">
        <div class="listing_table_head_wrapper">
          <div class="listing_table_column bottom_line w-50">
            <div class="tab">{{translate('Name')}}</div>
          </div>
          <div class="listing_table_column w-35">
            <div class="tab">{{translate('Permission')}}</div>
          </div>
          <div class="listing_table_column w-15">

          </div>
        </div>
        <div class="listing_table_body_wrapper">
          <div class="listing_table_row" ng-click="openGroup($event,group, $index)" ng-repeat="group in groups">
            <div class="listing_table_column w-50">
              <span class="number">{{$index + 1}}</span>
              <div class="name">{{group.group_name}}</div>
            </div>
            <div class="listing_table_column w-35">
              <gh-radio-button class="gh-radio-button" gh-options="options" gh-model="group.group_permission" gh-mode="current_value" editable="false"/> +
            </div>
            <div class="listing_table_column w-15">
              <span ng-click="onDeleteIconClick(group)" ng-show="group.group_permission === 1 || group.group_permission === 2" class="delete_icon" gh-icon="rubbish 0d99ff 20px"></span>
            </div>

          </div>
          <div ng-if="!groups.length" class="listing_table_nodata">
            <p>{{translate('No Groups')}}</p>
          </div>
        </div>

      </div>`

    }
  }]);
